export type UserRole = 'super_admin' | 'admin';

export type AgentType = 'NA' | 'PA' | 'TMA';

export interface AgentInfo {
  id: AgentType;
  name: string;
  fullName: string;
}

export const AGENTS: Record<AgentType, AgentInfo> = {
  NA: {
    id: 'NA',
    name: 'Nukyat Agent',
    fullName: 'Nukyat Agent (Operator ID NA)'
  },
  PA: {
    id: 'PA',
    name: 'Parotion Agent',
    fullName: 'Parotion Agent (Operator ID PA)'
  },
  TMA: {
    id: 'TMA',
    name: 'T Moita Agent',
    fullName: 'T Moita Agent (Operator ID TMA)'
  }
};

export interface ExtendedUserProfile {
  uid: string;
  email: string | null;
  displayName: string | null;
  emailVerified: boolean;
  role: UserRole;
  agentType?: AgentType;
  selectedAgent?: AgentType;
}

export interface UserPermissions {
  canManageLedger: boolean;
  canModifyClients: boolean;
  canAddClients: boolean;
  canViewAllClients: boolean;
  canManageUsers: boolean;
}
